import React from 'react';
import styled from 'styled-components';
import useMainContext from '../../hooks/main-provider';
import { useSidebar } from '../../contexts/SidebarContext';
import { STATIC_ASSETS_URL } from '../constants';
import Region from '../Buttons/MenuSidebar/Region';
import Districts from '../Buttons/MenuSidebar/Districts';
import ShopsSelectField from '../Buttons/MenuSidebar/ShopsSelectField';

const Icons = {
  sidebarCollapse: `${STATIC_ASSETS_URL}/icons/sidebar-collapse.svg`,
  sidebarExpand: `${STATIC_ASSETS_URL}/icons/sidebar-expand.svg`,
};

const Container = styled.div`
  display: flex;
  background: #412473 !important;
  width: 100%;
  height: 55px;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(77, 74, 74, 0.3);
  padding: 0 40px;
  gap: 20px;
  position: relative;
`;

const ToggleButton = styled.div`
  position: absolute;
  left: 10px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ToggleIcon = styled.img`
  width: 25px;
  height: 25px;
  filter: brightness(0) invert(1);
`;

const TopNavBar = () => {
  const { selectedOrganization } = useMainContext();
  const { isCollapsed, toggleSidebar } = useSidebar();

  return (
    <Container>
      <ToggleButton onClick={toggleSidebar}>
        <ToggleIcon
          src={isCollapsed ? Icons.sidebarExpand : Icons.sidebarCollapse}
          alt={isCollapsed ? 'Expand' : 'Collapse'}
        />
      </ToggleButton>
      {selectedOrganization && <Region />}
      {selectedOrganization && <Districts />}
      {selectedOrganization && <ShopsSelectField />}
    </Container>
  );
};

export default TopNavBar;
